import { useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './BellIcon.css';

/**
 * Bell icon with hover effects and tooltip for notifications
 @param {string} tooltipText 
 */
const BellIcon = ({ tooltipText = "Notifications" }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="icon-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`icon-circle ${isHovered ? 'icon-hover' : ''}`}>
        <NotificationsIcon />
      </div>
      {isHovered && <div className="tooltip">{tooltipText}</div>}
    </div>
  );
};

export default BellIcon;